export const ui_LoadingMixin = {
    props: {
        loading: {
            type: Number,
            default: 0,
        },
    },
    data: function() {
        return {
            classLoading: '',
            controlLoading: null,
        };
    },
    watch: {
        loading: {
            //Evitar que se ejecute si se quita el loading y se activa de nuevo en el momento
            immediate: true,
            handler(val) {
                if (this.controlLoading) clearTimeout(this.controlLoading);
                if (val > 0) this.classLoading = 'u-loading';
                else this.controlLoading = setTimeout(() => (this.classLoading = ''), 10);
            },
        },
    },
};
